import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector, Field } from 'redux-form';
import { FormattedMessage } from 'translations';
import { Layout } from 'app/components/base/Layout';
import CompactInput from 'app/components/base/CompactInput';
import Button from 'app/components/base/Button';
import { addAccountId, removeAccountId } from 'app/actions/book-trip';
import { getUser } from 'app/sagas/selectors';
import {
  BOOK_TRIP_FORM,
  ACCOUNT_ID_FIELD_NAME,
  ACCOUNT_ID_STATUS
} from 'app/constants';

import style from './style.css';


const messages = {
  title: { id: 'BOOK_TRIP.BOOK_FOR_SOMEONE_ELSE.TITLE' },
  placeholder: { id: 'BOOK_TRIP.BOOK_FOR_SOMEONE_ELSE.INPUT_PLACEHOLDER' },
  addButtonLabel: { id: 'BOOK_TRIP.BOOK_FOR_SOMEONE_ELSE.ADD_BUTTON_LABEL' },
  removeButtonLabel: { id: 'BOOK_TRIP.BOOK_FOR_SOMEONE_ELSE.REMOVE_BUTTON_LABEL' }
};

/**
 * Component that provides a text input field where users with the proper permissions
 * can enter a TA account email and book in its behalf.
 */
const BookOnBehalfOf = ({
  onAddAccountId,
  onRemoveAccountId,
  canBookOnBehalf,
  savedValue,
  updating
}) => {
  const buttonProps = {
    rounded: true,
    nocaps: true,
    disabled: updating
  };
  return (
    canBookOnBehalf && <Layout className={style.container} direction="column" size="100">
      <Layout className={style.label}>
        <FormattedMessage {...messages.title} />
      </Layout>
      <Layout direction="row" size="100" align="space-between stretch">
        <Field
          name={ACCOUNT_ID_FIELD_NAME}
          type="text"
          className={style.input}
          component={CompactInput}
          placeholder={<FormattedMessage {...messages.placeholder} />}
          nolabel
          disabled={updating || !!savedValue}
        />
        {!!savedValue &&
          <Button
            { ...buttonProps }
            className={style.removeButton}
            onClick={() => onRemoveAccountId()}
          >
            <FormattedMessage {...messages.removeButtonLabel} />
          </Button>
        }
        {!savedValue &&
          <Button
            { ...buttonProps }
            onClick={() => onAddAccountId()}
          >
            <FormattedMessage {...messages.addButtonLabel} />
          </Button>
        }
      </Layout>
    </Layout>
  );
};

// TODO: move to Flow types
// BookOnBehalfOf.propTypes = {
//   onAddAccountId: PropTypes.func,
//   onRemoveAccountId: PropTypes.func,
//   canBookOnBehalf: PropTypes.bool,
//   savedValue: PropTypes.string
// };

const mapStateToProps = (state, { formName = BOOK_TRIP_FORM }) => {
  const selector = formValueSelector(formName);
  const user = getUser(state);
  const { savedValue, updating } = selector(state, ACCOUNT_ID_STATUS);

  return {
    canBookOnBehalf: user && user.travel_agents_credits,
    savedValue,
    updating
  };
};

export default compose(
  connect(mapStateToProps, {
    onAddAccountId: addAccountId,
    onRemoveAccountId: removeAccountId
  })
)(BookOnBehalfOf);
